// src/components/Sidebar.jsx

import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import {
  FaSignOutAlt,
  FaChartLine,
  FaMoneyBillWave,
  FaUsers,
  FaBox,
  FaFileInvoiceDollar,
  FaStore,
  FaBuilding,
  FaTasks
} from "react-icons/fa";

const Sidebar = ({ userRole, handleLogout }) => {
  // Pull the stored userName and capitalize the first letter
  const rawName = sessionStorage.getItem("userName") || "";
  const userName = rawName
    ? rawName.charAt(0).toUpperCase() + rawName.slice(1)
    : "";

  // Normalize the role key for looking up menuItems
  const roleKey = userRole === "team_leader" ? "teamleader" : userRole;

  // Define all possible menu items for each role
  const menuItems = {
    admin: [
      { path: "/admin/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/admin/attendance", label: "Attendance", icon: <FaTasks /> },
      { path: "/admin/employees", label: "Manage Employees", icon: <FaUsers /> },
      { path: "/admin/departments", label: "Departments", icon: <FaBuilding /> },
      { path: "/admin/assets", label: "Assets", icon: <FaBox /> },
      { path: "/admin/assetlogs", label: "Asset Logs", icon: <FaFileInvoiceDollar /> },
      
    ],
    teamleader: [
      { path: "/team-leader/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/team-leader/attendence", label: "Attendance", icon: <FaTasks /> },
      { path: "/team-leader/employees", label: "Employees", icon: <FaUsers /> },
      { path: "/team-leader/assets", label: "Assets", icon: <FaBox /> },
      { path: "/team-leader/assetlogs", label: "Asset Logs", icon: <FaFileInvoiceDollar /> },
      { path: "/team-leader/tasks", label: "Tasks", icon: <FaTasks /> },
    
    ],
    employee: [
      { path: "/employee/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/employee/attendance", label: "Attendance", icon: <FaTasks /> },
      { path: "/employee/tasks", label: "Tasks", icon: <FaTasks /> },
      { path: "/employee/assets", label: "Assets", icon: <FaBox /> },
      { path: "/employee/assetrequests", label: "Asset Requests", icon: <FaFileInvoiceDollar /> },
      
    ],
    hr: [
      { path: "/hr/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/hr/attendance", label: "Attendance", icon: <FaTasks /> },
      { path: "/hr/employees", label: "Manage Employees", icon: <FaUsers /> },
      
      { path: "/hr/asset-requests", label: "Asset Logs", icon: <FaBox /> },  // <== ADD THIS
    ],
    
    accounts: [
      { path: "/accounts/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/accounts/attendance", label: "Attendance", icon: <FaTasks /> },

      { path: "/accounts/expenses", label: "Expenses", icon: <FaMoneyBillWave /> },
      { path: "/accounts/salaries", label: "Salaries", icon: <FaUsers /> },
      { path: "/accounts/vendorpayments", label: "Vendor Payments", icon: <FaFileInvoiceDollar /> },
      { path: "/accounts/assetlogs", label: "Asset Logs", icon: <FaFileInvoiceDollar /> },
    ],
    finance: [
      { path: "/finance/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/finance/attendance", label: "Attendance", icon: <FaTasks /> },
      { path: "/finance/expenses", label: "Expenses", icon: <FaMoneyBillWave /> },
      { path: "/finance/salaries", label: "Salaries", icon: <FaUsers /> },
      { path: "/finance/vendorpayments", label: "Vendor Payments", icon: <FaFileInvoiceDollar /> },
      { path: "/finance/assetlogs", label: "Asset Logs", icon: <FaFileInvoiceDollar /> },
      { path: "/finance/investmentplans", label: "Investment Plans", icon: <FaStore /> },
    ],
    procurement: [
      { path: "/procurement/dashboard", label: "Dashboard", icon: <FaChartLine /> },
      { path: "/procurement/attendance", label: "Attendance", icon: <FaTasks /> },
      { path: "/procurement/assetrequests", label: "Asset Requests", icon: <FaBox /> },
      { path: "/procurement/vendormanagement", label: "Vendor Management", icon: <FaUsers /> },
      { path: "/procurement/purchaseorders", label: "Purchase Orders", icon: <FaFileInvoiceDollar /> },
      { path: "/procurement/inventory", label: "Inventory", icon: <FaStore /> },
      { path: "/procurement/assetlogs", label: "Asset Logs", icon: <FaFileInvoiceDollar /> },
    ],
  };

  return (
    <div
      className="d-flex flex-column p-3 text-white vh-100"
      style={{ width: "250px", backgroundColor: "#1e1e2f" }}
    >
      {/* Sidebar Header */}
      <h5 className="text-center mb-4">
        Welcome {userName} 😊!!
      </h5>

      {/* Navigation Links */}
      <Nav className="flex-column">
        {menuItems[roleKey]?.map((item, idx) => (
          <Nav.Link
            key={idx}
            as={NavLink}
            to={item.path}
            className="sidebar-item d-flex align-items-center text-light py-2 px-3"
          >
            {item.icon}
            <span className="ms-2">{item.label}</span>
          </Nav.Link>
        ))}

        {/* Logout Button */}
        <Nav.Link
          onClick={handleLogout}
          className="sidebar-logout d-flex align-items-center mt-auto py-2 px-3"
        >
          <FaSignOutAlt className="me-2" /> Logout
        </Nav.Link>
      </Nav>

      
      {/* Sidebar Styles */}
      {/* <style jsx>{`
        .sidebar {
          width: 250px;
          min-height: 100vh;
          background-color: #1e1e2f;
          color: white;
        }
        .sidebar-item {
          display: flex;
          align-items: center;
          text-decoration: none;
          font-size: 1rem;
          transition: background 0.2s ease-in-out;
          border-radius: 5px;
        }
        .sidebar-item:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        .sidebar-logout {
          margin-top: auto;
          color: #dc3545;
          font-weight: bold;
          cursor: pointer;
          border-radius: 5px;
          transition: background 0.2s ease-in-out;
        }
        .sidebar-logout:hover {
          background: rgba(255, 0, 0, 0.2);
        }
      `}</style> */}
    </div>
  );
};

export default Sidebar;
